import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/dropfile.svg
 */
const IconDropfile: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 14.994c.69 0 1.25.56 1.25 1.251v5.253h19v-5.253a1.25 1.25 0 112.5 0v6.504c0 .69-.56 1.251-1.25 1.251H1.25C.56 24 0 23.44 0 22.749v-6.504c0-.69.56-1.25 1.25-1.25z"
      fill="currentColor"
    />
    <path
      d="M11.115 18.29c.096.085.205.155.323.207.017 0 .038.01.055.017l.074.025c.266.097.56.097.826 0 .024 0 .047-.014.072-.025.024-.01.038 0 .057-.017.117-.052.225-.122.321-.207l7.187-6.257a1.294 1.294 0 00.12-1.839 1.315 1.315 0 00-.903-.44 1.322 1.322 0 00-.953.32l-5.002 4.357V1.303c0-.345-.139-.677-.386-.921a1.32 1.32 0 00-1.859 0 1.298 1.298 0 00-.385.921v13.128L5.66 10.075a1.322 1.322 0 00-1.855.12 1.294 1.294 0 00.12 1.838l7.19 6.257z"
      fill="currentColor"
    />
  </svg>
);

export default IconDropfile;
